import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {GetSetDataService} from '../../services/get-set-data.service';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {LoginUserComponent} from '../login-user/login-user.component';

@Component({
  selector: 'app-top-view',
  templateUrl: './top-view.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    LoginUserComponent
  ],
  styleUrls: ['./top-view.component.scss']
})
export class TopViewComponent {

  private hiddenMenuClass = 'menu-hidden';

  public loginURL = environment.LOGIN_URL;

  constructor(private getSetData: GetSetDataService) {
  }

  toggleNavigation() {
    const elementBody = document.getElementsByTagName('body')[0];

    if (elementBody.className.indexOf(this.hiddenMenuClass) >= 0) {
      elementBody.classList.remove(this.hiddenMenuClass);
    } else {
      elementBody.classList.add(this.hiddenMenuClass);
    }
  }

  public resetSearchQuery() {
    this.getSetData.globalSearchQuery = '';
    this.getSetData.EmitterSearch.next('');
  }
}
